import tw from "tailwind-styled-components";
import { FaHandHoldingUsd, FaBed, FaRupeeSign, FaUsers, FaHouseUser, FaPeopleArrows, FaBuilding, FaUndoAlt, FaHome, FaChartLine, FaCalendar, FaBroom } from "react-icons/fa";
import { GiExpense } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import {
    MdOutlineHeadsetMic,
} from "react-icons/md";
import { TbActivity, TbBrandBooking } from "react-icons/tb";
import { FaPersonWalking } from "react-icons/fa6";
import { useSelector } from "react-redux";
import Config from "../../Config";
const CardGrid = tw.div`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8`;
const Card = tw.div`border border-gray-200 cursor-pointer rounded-lg py-6 px-4 flex flex-col gap-4 shadow-sm hover:shadow-md transition duration-300`;
const IconWrapper = tw.div`w-10 h-10 rounded-md bg-blue-100 flex items-center justify-center text-primary-color text-lg`;
const CardTitle = tw.h3`text-base font-semibold text-gray-800`;
const CardDesc = tw.p`text-sm text-gray-600`;
const DownloadLink = tw.a`text-sm font-medium text-blue-500 hover:underline`;

const ProductReport = ({ tenantAttendanceEnabled }) => {

    const navigate = useNavigate();
    const user = useSelector((state) => state.UserReducer.user);
    const isSalesPerson = user &&
        user?.role === Config.STAFF_ROLES.SALES_HEAD;
    const salesPersonReportTypes = [8, 11];
    const allReports = [
        {
            icon: <FaUsers />,
            title: "Tenant",
            desc: "Fetch tenant data like tenant name, mobile, address, move-in date, pending dues etc.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 3,
        },
        {
            icon: <FaHouseUser />,
            title: "Room Occupancy",
            desc: "Fetch occupancies data like tenant name, move-in date, pending dues etc.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 5,
        },
        {
            icon: <FaBed />,
            title: "Bed Occupancy",
            desc: "Fetch occupancies data like tenant name, move-in date, pending dues etc.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 6,
        },
        {
            icon: <FaHandHoldingUsd />,
            title: "Collections",
            desc: "Fetch transactional data like amount collected, collection type, mode of payment etc.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 1,
        },
        {
            icon: <FaRupeeSign />,
            title: "Dues",
            desc: "Fetch pending dues data like due amount, due type, due date etc..",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 2,
        },
        {
            icon: <GiExpense />,
            title: "Expenses",
            desc: "Fetch a summary of all expenses related to property maintenance and management etc..",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 4,
        },
        {
            icon: <MdOutlineHeadsetMic />,
            title: "Complaints",
            desc: "Fetch a summary of all complaints raised regarding properties issues..",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 7,
        },
        {
            icon: <FaPeopleArrows />,
            title: "Leads",
            desc: "Fetch a summary of new leads generated details, track the status, marketing channels etc.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 8,
        },
        {
            icon: <TbBrandBooking />,
            title: "Booking",
            desc: "View detailed insights on new bookings, their status, customer sources, and overall booking performance.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 11,
        },
        {
            icon: <FaBuilding />,
            title: "Property",
            desc: "View comprehensive property details, occupancy stats, rent status, and overall property performance.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 12,
        },
        {
            icon: <TbActivity />,
            title: "Activity Log",
            desc: "Track and review a complete history of system activities, including user actions, updates, and important events for monitoring and auditing purposes.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 9,
        },
        {
            icon: <FaPersonWalking />,
            title: "Moved Out Tenants",
            desc: "Manage and review tenants who have moved out, including move-out dates and occupancy status updates.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 10,
        },
        {
            icon: <FaBuilding />,
            title: "Property Lease",
            desc: "View and download detailed property lease reports, including lease duration, tenant details, and agreement status.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 13,
        },
        {
            icon: <FaUndoAlt />,
            title: "Refund Request",
            desc: "Access and download comprehensive refund request reports, including bank details.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 14,
        },
        {
            icon: <FaHome />,
            title: "Rent Review Report",
            desc: "Access and download detailed rent reports, including payment history, tenant details, and due amounts.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 15,
        },
        {
            icon: <FaChartLine />,
            title: "Profit & Loss Report",
            desc: "Generate a comprehensive profit and loss statement with total income, expenses, net profit, and financial performance for the selected period.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 16,
        },
        {
            icon: <FaBroom />,
            title: "Housekeeping Report",
            desc: "Generate a detailed housekeeping report covering cleaning schedules, task completion status for the selected period.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 18,
        },
    ];
    // Conditionally add Tenant Attendance report only if enabled
    if (tenantAttendanceEnabled === 1) {
        allReports.push({
            icon: <FaCalendar />,
            title: "Tenant Attendance",
            desc: "Generate a detailed tenant attendance report and attendance status for the selected period.",
            path: "/create-reports",
            linkText: "Download Report",
            reportType: 17,
        });
    }
    const reports = isSalesPerson
        ? allReports.filter(report => salesPersonReportTypes.includes(report.reportType))
        : allReports;

    return (

        <CardGrid>
            {reports.map((report, index) => (
                <Card key={index} onClick={() => navigate(report.path, { state: { reportType: report.reportType } })}>
                    <div className="flex gap-4 items-center">
                        <IconWrapper>{report.icon}</IconWrapper>
                        <CardTitle>{report.title}</CardTitle>
                    </div>
                    <CardDesc>{report.desc}</CardDesc>
                    <DownloadLink>Download Report</DownloadLink>
                </Card>
            ))}
        </CardGrid>

    );
};

export default ProductReport;
